import {
  Grid,
  Typography,
  Box,
} from "@material-ui/core";
import React, { useState } from "react";
import { TextField, Select } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import MuiLink from "@material-ui/core/Link";
import { Alert, Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const LinkComponent = withStyles({
  root: {
    "&[disabled]": {
      color: "grey",
      cursor: "default",
      "&:hover": {
        textDecoration: "none",
      },
    },
  },
})(MuiLink);

const OutlinedTextFiled = withStyles((theme) => ({
  root: {
    "& input::placeholder": {
      fontSize: "0.75rem !important",
    },
    "& .MuiOutlinedInput-input": {
      padding: "0.62rem  !important",
      color: theme.palette.eDark?.base + " !important"
    },
    "& .MuiInputBase-input": {
      fontSize: "0.75rem !important",
      color: theme.palette.eDark?.base + " !important"
    },
    "& .MuiInputBase-input:focus": {
      fontSize: "1rem !important",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: theme.palette.eDanger?.dark,
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.eDanger?.dark,
    },
    "& ::placeholder": {
      color: theme.palette.eDark?.base,
    },
    
  },
}))(TextField);

const useStyles = makeStyles((theme) => ({
  errorMsgRightAlign: {
    "& .MuiFormHelperText-contained": {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  dialogTitle: {
    color: theme.palette.eWhite.base,
    backgroundColor: theme.palette.ePrimary.base,
  },
  dialog: {
    position: "relative",
    zIndex: 300 + "!important",
    "& .MuiDialog-paper": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "400px",
      },
    },
  },
  textCenter: {
    textAlign: "center",
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  verifyButton: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 15%",
    whiteSpace: "nowrap",
  },
  disableButton: {
    "& .Mui-disabled": {
      backgroundColor: theme?.palette?.eLight?.base,
      color: theme.palette.eWhite.base,
    },
  },
  circularLoading: {
    color: theme.palette.eWhite.base,
  },
  alertStyle: {
    color: theme.palette.eDanger.dark,
    backgroundColor: theme.palette.eDanger.light,
  },
  verifyRightAlign: {
    justifyContent: "flex-end",
    "& .MuiLink-button": {
      color: theme.palette.ePrimary.base,
    },
  },
  displayFlex: {
    display: "flex",
  },
  phoneInputPadding: {
    "& #registeredCell_Id": {
      padding: 7,
      borderRadius: 4,
      borderColor: "lightgrey !important",
      borderWidth: "thin",
    },
  },
  errorMsgRightAlignMobile: {
    marginLeft: 0,
    marginRight: 0,
    display: "flex",
    justifyContent: "flex-end",
  },
  userVerified: {
    color: theme.palette.eSecondary.base,
  },
  userVefiy: {
    whiteSpace: "nowrap",
  },
  verifyIcon: {
    fontSize: "small",
  },
  boxPaddingRight: {
    paddingRight: "1rem !important",
    [theme.breakpoints.down("xs")]: {
      paddingRight: "0 !important",
    },
  },
  verifyTopPadding: {
    paddingTop: "0.313rem",
  },
  asterisk: {
    color: theme.palette.eDanger?.dark,
  },
  defaultColor: {
    color: theme?.palette?.eMedium?.base + "!important",
  },
  secondaryColor: {
    color: theme.palette.ePrimary.base + " !important",
    padding: 2,
    "& .MuiSvgIcon-root": {
      fontSize: 17,
    },
  },
  radioLabel: {
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  husbandRadio: {
    marginLeft: -2,
    marginRight: 5,
  },
  countryCodePadding: {
    paddingTop: "1vh !important",
  },
  textColor:{
    color:theme?.palette?.eDark?.base + "!important"
  }
}));

function EExistingApplicantDetails(props) {
  const {
    setOpenMobileDialog,
    husbandWifeRadio,
    sethusbandWifeRadio,
    existingCustomer,
    userEnteredMobileNumber,
    setuserEnteredMobileNumber,
    masterDataEmail,
    masterDataName,
    masterDataIdValue,
    masterDataTinValue,
    masterDataFatherName,
    masterDataMotherName,
    masterDataHusbandName,
    masterDatahusbandWifeRadio,
  } = props;

  const classes = useStyles();
  const { t: content, ready: contentReady } = useTranslation(
    "content-E_APPLICANT_DETAILS_SCREEN"
  );
  const applicantLabels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS
  );
  const country_Calling_Code = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_PHONE_NUMBER_EXTENSION
  );
  const userNameLength = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.USERNAME_LENGTH
  );
  const mobileLength = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.MOBILE_LENGTH
  );
  const nameMinLength = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.NAME_MIN_LENGTH
  );
  const emailRegex = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.EMAIL_REGEX
  );
  const landlineMaxLength = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_LANDLINE_MAX_LENGTH
  );
  const mobileRegex = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.E_APPLICANT_MOBILE_REGEX
  );
  const { t: applicantLabel, ready: applicantLabelReady } = useTranslation(
    "label-E_APPLICANT_DETAILS"
  );


  const handleClose = () => {
    setOpenMobileDialog(false);
  };
  return (
    <Grid container spacing={0} direction="row">
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
              {applicantLabelReady ? (
                <Typography variant="caption">
                  {applicantLabel("E_APPLICANT_NAME")}
                  <span className={classes.asterisk}>*</span>
                </Typography>
              ) : (
                <Skeleton />
              )}
              <OutlinedTextFiled
                variant="outlined"
                name="name"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={masterDataName}
                disabled={true}
                autoComplete="off"
                placeholder={
                  applicantLabelReady
                    ? applicantLabel("E_APPLICANT_NAME_PLACEHOLDER")
                    : ""
                }
                helperText={
                    <div>&nbsp;</div>
                }
                className={[classes.textColor]}
              />
            </Grid>

            <Grid item xs={12} >
              {applicantLabelReady ? (
                <Typography variant="caption">
                  {applicantLabel("E_APPLICANT_FATHERS_NAME")}
                  <span className={classes.asterisk}>*</span>
                </Typography>
              ) : (
                <Skeleton />
              )}
              <OutlinedTextFiled
                variant="outlined"
                name="fatherName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={masterDataFatherName}
                disabled={true}
                placeholder={
                  applicantLabelReady
                    ? applicantLabel("E_APPLICANT_FATHERS_NAME_PLACEHOLDER")
                    : ""
                }
                helperText={
                  <div>&nbsp;</div>
              }
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>

            <Grid item xs={12} >
              <Typography variant="caption">
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="gender"
                    row
                    name="husbandWifeRadio"
                    value={masterDatahusbandWifeRadio}
                  >
                    <FormControlLabel
                      value="husband"
                      control={<Radio className={[classes.secondaryColor]} />}
                      label={
                        <Typography variant="caption">
                          {applicantLabelReady
                            ? applicantLabel("E_APPLICANT_HUSBAND_NAME")
                            : ""}
                        </Typography>
                      }
                      className={[classes.radioLabel, classes.husbandRadio]}
                    />
                    <FormControlLabel
                      value="wife"
                      control={<Radio className={[classes.secondaryColor]} />}
                      label={
                        <Typography variant="caption">
                          {applicantLabelReady
                            ? applicantLabel("E_APPLICANT_WIFE_NAME")
                            : ""}
                        </Typography>
                      }
                      className={classes.radioLabel}
                    />
                  </RadioGroup>
                </FormControl>
              </Typography>

              <OutlinedTextFiled
                variant="outlined"
                name="husbandName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                value={masterDataHusbandName}
                disabled={true}
                autoComplete="off"
                placeholder={
                  husbandWifeRadio == "husband"
                    ? applicantLabelReady
                      ? applicantLabel("E_APPLICANT_HUSBANDS_NAME_PLACEHOLDER")
                      : ""
                    : applicantLabelReady
                    ? applicantLabel("E_APPLICANT_WIFES_NAME_PLACEHOLDER")
                    : ""
                }

                helperText={
                  <div>&nbsp;</div>
              }
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Box className={classes.boxPaddingRight}>
          <Grid container spacing={1} direction="row">
            <Grid item xs={12}>
              <Grid container justify="space-between">
                <Grid item xs="auto">
                  <Typography variant="caption">
                    {applicantLabels?.E_APPLICANT_MOBILE_NUMBER}
                    <span className={classes.asterisk}>*</span>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={2} className={classes.countryCodePadding}>
                  <Typography variant="caption">
                    {country_Calling_Code}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <OutlinedTextFiled
                    variant="outlined"
                    name="mobile"
                    fullWidth
                    inputProps={{
                      maxLength: Number(mobileLength),
                    }}
                    value={userEnteredMobileNumber}
                    disabled={true}
                    autoComplete="off"
                    placeholder={
                      applicantLabels?.E_APPLICANT_MOBILE_NUMBER_PLACEHOLDER
                    }
                    helperText={
                      <div>&nbsp;</div>
                  }
                    className={[classes.errorMsgRightAlign]}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} >
              {applicantLabelReady ? (
                <Typography variant="caption">
                  {applicantLabel("E_APPLICANT_MOTHERS_NAME")}
                </Typography>
              ) : (
                <Skeleton />
              )}
              <OutlinedTextFiled
                variant="outlined"
                name="motherName"
                fullWidth
                inputProps={{
                  maxLength: Number(userNameLength),
                }}
                disabled={true}
                value={masterDataMotherName}
                autoComplete="off"
                placeholder={
                  applicantLabelReady
                    ? applicantLabel("E_APPLICANT_MOTHERS_NAME_PLACEHOLDER")
                    : ""
                }
              helperText={
                    <div>&nbsp;</div>
                }
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>

            <Grid item xs={12} >
              <Typography variant="caption">
                {applicantLabels?.E_APPLICANT_EMAIL_ID}
              </Typography>
              <OutlinedTextFiled
                variant="outlined"
                name="email"
                fullWidth
                maxLength={Number(userNameLength)}
                value={masterDataEmail}
                disabled={true}
                autoComplete="off"
                placeholder={applicantLabels?.E_APPLICANT_EMAIL_ID_PLACEHOLDER}
                className={[classes.errorMsgRightAlign]}
              />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default EExistingApplicantDetails;
